import React from 'react';
import { SettingsProfileCard } from './SettingsProfileCard';
import { SettingsEmailCard } from './SettingsEmailCard';
import { SettingsConnectedAccountsCard } from './SettingsConnectedAccountsCard';

export const SettingsProfileSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <SettingsProfileCard />
      <SettingsEmailCard />
      <SettingsConnectedAccountsCard />
    </div>
  );
};

export default SettingsProfileSection;
